import React from 'react'

import Font from 'src/components/Core/Typography/Font/Font'
import ArrowDots from 'src/components/Core/Logo/ArrowDots'
import { Background, BackgroundLeftColumn, BackgroundRightColumn, MainSection } from '../Home/Home.styles'
import { Trans } from 'react-i18next'
import Icon from 'src/components/Core/Iconography/Icon/Icon'

// @ts-ignore:next-line
const NoApplications = () => {

  return (
    <>
      <Background justifyContent='space-between'>
        <BackgroundLeftColumn>
        </BackgroundLeftColumn>
        <BackgroundRightColumn>
          <ArrowDots />
        </BackgroundRightColumn>
      </Background>
      <MainSection flexDirection='column'>
        <Icon size='xxl' color='warning' name='warning'/>
        <Font tag='h4' color='blank' textAlign='center' margin='40px 80px 80px'>
          {/* @ts-ignore:next-line */}
          {<Trans i18nKey={'onboarding.noapplications'} />}
        </Font>
      </MainSection>
    </>
  )
}

export default NoApplications
